import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import copy from 'copy-to-clipboard'
import styled from 'styled-components'

import Button from 'components/Shared/Button/Index'
import Modal from 'components/Shared/Modal/Index'
import ModalHeader from 'components/Shared/Modal/ModalHeader'
import ModalBody from 'components/Shared/Modal/ModalBody'
import ModalFooter from 'components/Shared/Modal/ModalFooter'

import Table from 'components/Shared/TableNew/Index'
import TableBody from 'components/Shared/TableNew/TableBody'
import TableFormRow from 'components/Shared/TableForm/TableFormRow'
import TableFormValueCell from 'components/Shared/TableForm/TableFormValueCell'

import Tooltip from 'components/Shared/Tooltip/Index'

const Text = styled.div`
  user-select: none;
  text-align: center;
  padding: 10px;
`

const SecretModal = ({ visible, onClose, secret }) => {
  const { t } = useTranslation()

  return (
    <Modal
      open={visible}
      closeModal={onClose}
    >
      <ModalHeader closeModal={onClose} withNotification>
        {t('satSecretsPage.secretModal.title')}
      </ModalHeader>

      <ModalBody>
        <Text>{t('satSecretsPage.secretModal.notification')}</Text>
        <Table width='512px'>
          <TableBody>
            <TableFormRow>
              <TableFormValueCell align='center'>{secret}</TableFormValueCell>
            </TableFormRow>
          </TableBody>
        </Table>
      </ModalBody>

      <ModalFooter>
        <Tooltip
          id='modal-footer-tooltip'
          place='left'
          delayHide={500}
          openEvents={{ click: true }}
          closeEvents={{ mouseleave: true }}
        />

        <Button
          large
          data-tooltip-id='modal-footer-tooltip'
          data-tooltip-content={t('satSecretsPage.secretModal.copiedTooltip')}
          onClick={async () => {
            await copy(secret)
          }}
        >
          {t('satSecretsPage.secretModal.copyButton')}
        </Button>

        <Button
          large
          secondary
          onClick={onClose}
        >
          {t('common.close')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

SecretModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  secret: PropTypes.string.isRequired,
}

export default SecretModal
